export default "__VITE_ASSET__wUBgXrrT__"